import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

type ButtonThemes =
  | 'primary'
  | 'secondary'
  | 'danger'
  | 'warning'
  | 'success'
  | 'info';

@Component({
  selector: 'wl-async-button',
  templateUrl: './async-button.component.html',
  styleUrls: ['./async-button.component.scss'],
  standalone: true,
  imports: [AutomationIdDirective, FaIconComponent],
})
export class AsyncButtonComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() theme: ButtonThemes = 'primary';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() disabled = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isLoading = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() outline = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() automationId?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() size?: 'sm' | 'lg';

  @Output() buttonClick = new EventEmitter<MouseEvent>();

  get buttonThemeCssClass() {
    return `btn${this.buttonOutline}-${this.theme}`;
  }

  get buttonSizeCssClass() {
    return this.size ? `btn-${this.size}` : '';
  }

  get buttonOutline() {
    return this.outline ? `-outline` : '';
  }

  get spinnerVisibility() {
    return this.isLoading ? 'invisible' : '';
  }
}
